import { render, staticRenderFns } from "./manage-grouping-rules-modal.vue?vue&type=template&id=af165308"
import script from "./manage-grouping-rules-modal.vue?vue&type=script&lang=js"
export * from "./manage-grouping-rules-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports